<template>
    <div class="search-results__filters-section">
        <div class="search-results__filters-section-label" @click="sectionVisible = !sectionVisible">
            <h4 class="search-results__filters-section-title">{{ title }}</h4>
            <div class="search-results__filters-section-summary">{{ selectedSummary }}</div>
            <img src="/images/used/filters-arrow.svg" class="search-results__filters-section-arrow" :class="{ 'search-results__filters-section-arrow--open': sectionVisible }" />
        </div>
        <div class="search-results__filters-section-content" :class="{ 'search-results__filters-section-content--hidden': !sectionVisible }">
            <template v-if="type == 'checkbox'">
                <div v-if="enableSearch">
                    <input class="search-results__filters-search form-element__input " type="text" placeholder="Model" v-model="searchValue" />
                </div>
                <template v-for="(option, index) in filteredOptions">
                    <div :key="index" :class="{'search-results__filters-section-filter--hidden': (index > 12 && !showAll) }">
                        <input class="redesign-checkbox__input" type="checkbox" :id="uid + index" :value="option.value" v-model="selectedValue" />
                        <label v-if="hasCount" class="redesign-checkbox__label search-results__filters-section-checkbox search-results__filters-section-checkbox--has-count" :for="uid + index"><div class="redesign-checkbox__span redesign-checkbox__span--blue"></div><div>{{ option.label }}</div> <div class="search-results__filters-section-checkbox-count">{{ option.count }}</div></label>
                        <label v-else class="redesign-checkbox__label search-results__filters-section-checkbox" :for="uid + index"><span class="redesign-checkbox__span redesign-checkbox__span--blue"></span>{{ option.label }}</label>
                    </div>
                    <button v-if="(index == 12 && !showAll)" :key="'button' + index" @click="showAll = true" class="btn btn--fake-link search-results__filters-view-all">{{ viewAllText }} <img src="/images/used/view-all-icon.svg" class="search-results__filters-view-all-img" /></button>
                </template>
            </template>
            <template v-else-if="type == 'select'">
                <div class="form-element__container">
                    <select class="form-element__input" :disabled="loading" v-model="selectedValue">
                        <option value="">Any {{ title }}</option>
                        <template v-if="hasCount">
                            <option v-for="(option, index) in availableOptions" :value="option.value" :key="index">{{ option.label }} ({{ option.count }})</option>
                        </template>
                        <template v-else>
                            <option v-for="(option, index) in availableOptions" :value="option.value" :key="index">{{ option.label }}</option>
                        </template>
                    </select>
                </div>
            </template>
            <template v-else>
                <div class="form-element__container">
                    <input class="form-element__input" type="text" :placeholder="placeholder" v-model="selectedValue" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        title: {
            required: true,
        },
        placeholder: {
            required: false,
        },
        optionsKey: {
            required: true,
        },
        formatFunction: {
            required: false,
        },
        hasCount: {
            default: true,
            required: false,
        },
        type: {
            default: 'checkbox',
            required: false,
        },
        enableSearch: {
            default: false,
            required: false,
        }
    },
    data() {
        return {
            sectionVisible: false,
            showAll: false,
            searchValue:''
        };
    },
    computed: {
        ...mapGetters({
            userOptions: 'UsedSearchOptions/userOptions',
            loading: 'UsedSearchOptions/loading',
        }),
        selectedSummary() {
            if (this.type == 'checkbox') {
                const selectedValuesLength = this.selectedValue.length;
                if (selectedValuesLength == 0) {
                    return '';
                }
                if (selectedValuesLength == 1) {
                    return this.selectedValue[0];
                }
                let summary = this.selectedValue[0];
                for (let index = 1; index < selectedValuesLength; index++) {
                    summary = summary + ', ' + this.selectedValue[index];
                    if (index > 2) {
                        const remainder = selectedValuesLength - index - 1;
                        if (remainder > 0) {
                            summary = summary + ' and ' + remainder +' more';
                        }
                        break;
                    }
                }
                if (String(summary).length > 20) {
                    return selectedValuesLength + ' items';
                }
                return summary;
            }

            if (this.selectedValue === '') {
                return '';
            }

            if (this.formatFunction) {
                return this.formatFunction(this.selectedValue);
            }
            return this.selectedValue;
        },
        viewAllText() {
            return 'View all ' + this.title.toLowerCase() + 's';
        },
        availableOptions() {
            if (this.type == 'text') {
                return '';
            }

            const availableOptions = this.$store.state.UsedSearchOptions.options[this.optionsKey];
            if (!availableOptions) {
                return [];
            }

            if (this.formatFunction) {
                return availableOptions.map(availableOption => {
                    if (this.hasCount) {
                        return {
                            value: availableOption[this.optionsKey],
                            label: this.formatFunction(availableOption[this.optionsKey]),
                            count: availableOption.count,
                        };
                    }
                    return {
                        value: availableOption,
                        label: this.formatFunction(availableOption),
                    };
                })
            }

            return availableOptions.map(availableOption => {
                if (this.hasCount) {
                    return {
                        value: availableOption[this.optionsKey],
                        label: availableOption[this.optionsKey],
                        count: availableOption.count,
                    };
                }
                return {
                    value: availableOption,
                    label: availableOption,
                };
            });
        },
        filteredOptions() {
            if (!this.enableSearch || !this.searchValue) {
                return this.availableOptions;
            }

            const search = this.searchValue.toLowerCase();
            return this.availableOptions.filter(option =>
                option.label.toLowerCase().includes(search)
            );
        },
        selectedValue: {
            get() {
                return this.userOptions[this.optionsKey];
            },
            set (value) {
                this.gaTag('Used Vehicles - Refine Search', 'Interaction', this.title);
                this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                    [this.optionsKey]: value,
                });
            }
        },
        uid() {
            return this.optionsKey + '.' + this._uid;
        }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/UsedSearchResultsFilter.vue